import { createContext } from 'react';

const SeekerContext = createContext(null);

export default SeekerContext;
